import { useQuery, keepPreviousData } from '@tanstack/react-query'
import { ReservationsService, type Reservation } from '@/services/reservations'
import type { AdvancedFiltersState } from '@/components/reserves/AdvancedFilters'

interface UseReservationsParams {
    page: number
    searchTerm: string
    statusFilter: string
    advancedFilters: AdvancedFiltersState
    perPage?: number
}

interface ReservationsResponse {
    data: Reservation[]
    meta: {
        current_page: number
        per_page: number
        total: number
        total_pages: number
    }
}

export function useReservations({
    page,
    searchTerm,
    statusFilter,
    advancedFilters,
    perPage = 20
}: UseReservationsParams) {
    return useQuery({
        queryKey: ['reservations', { page, searchTerm, statusFilter, advancedFilters, perPage }],
        queryFn: async () => {
            const params = {
                page,
                search: searchTerm,
                estat: statusFilter === 'all' ? '' : statusFilter,
                per_page: perPage,
                ...advancedFilters,
            }
            const response = await ReservationsService.getAll(params)
            return response as ReservationsResponse
        },
        placeholderData: keepPreviousData,
        staleTime: 1000 * 60 * 1, // 1 minute
    })
}
